import NewCropsContainer from './NewCropsContainer';

export default NewCropsContainer;
